<template>
  <div class="home p-3">
    <Dashboard :names="this.nameArticle" :views="this.views" class="mb-2" v-if="user" />
    <HomeArticle :recentArticles="recentArticles" :popularArticles="popularArticles" />
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { mapState } from "vuex";
import Dashboard from "./Dashboard.vue";
import HomeArticle from "./HomeArticles.vue";
export default {
  name: "Home",
  components: { Dashboard, HomeArticle },
  data: function () {
    return {
      recentArticles: [],
      popularArticles: [],
      nameArticle: [],
      views: [],
    };
  },
  computed: mapState(["user"]),

  methods: {
    getRecentArticles() {
      axios
        .get(`${baseApiUrl}/api/publico/home/artigos`)
        .then((res) => {
          this.recentArticles = res.data.recentArticles;
          this.popularArticles = res.data.popularArticles;
          this.$store.commit("toggleFooter", true);
          this.getNamesAndViews();
        });

        
    },
    getNamesAndViews() {
      this.nameArticle = this.popularArticles.map((article) => article.name);
      this.views = this.popularArticles.map((article) => article.views);
    }
  },

  mounted() {
    this.$store.commit("toggleFooter", false);
    this.getRecentArticles();
  },
};
</script>